module.exports = ['estimate.footer.m1', 'estimate.footer.m2', 'estimate.footer.m3'];
